import appConstants from "../../../../../appConstants";
import { DropdownEditor } from '@dataGrid/components/cellEditors';
import {DropdownValueCellRenderer} from '@dataGrid/components/cellRenderer';

export default class GridConfig {
    constructor(configuration){
        const config = configuration || {};
        this.name = "GridConfiguration";
        this.config = GridConfig.getConfiguration(config);
    }
    static getConfiguration(config) {
      return GridConfig.getDefaultConfiguration();
    }

    
    static getDefaultConfiguration() {
    return {
      title: appConstants.gridNames.RouteEquipmentPreference,
      keyColumn: "routeName",
      defaultColDef: {
        sortable: false,
        resizable: false,
        cellDataType: false,
      },
      columns: [
        {
          headerName: "Route",
          field: "routeName",
          headerTooltip: "Route",
          minWidth: appConstants.columnWidth.ROUTE_EQMT_MAP_ROUTE,
        },
        {
          headerName: "Trailer",
          field: "trailerName",
          headerTooltip: "Trailer",
          editable: true,
          cellEditor: DropdownEditor,
          cellEditorPopup: true,
          minWidth: appConstants.columnWidth.ROUTE_EQMT_MAP_TRAILER,
          cellRenderer: DropdownValueCellRenderer,
        }     
      ]
    }
  }
}

